
import MessageTemplate from './routes/message_template/MessageTemplate.vue';
import MessageTest from './routes/message_test/MessageTest.vue';
import PaxelMarketMainHeader from './routes/main_header/PaxelMarketMainHeader.vue';
import PaxelMarketMeta from './routes/meta/PaxelMarketMeta.vue';
import PaxelMarketBasicService from './routes/basic_service/PaxelMarketBasicService.vue';
import CreatePaxelMarketBasicService from './routes/basic_service/component/createPaxelMarketBasicService.vue';
import EditPaxelMarketBasicService from './routes/basic_service/component/editPaxelMarketBasicService.vue';
import PaxelMarketMainFeatures from './routes/main_features/PaxelMarketMainFeatures.vue';
import CreatePaxelMarketMainFeatures from './routes/main_features/component/createPaxelMarketMainFeatures.vue';
import EditPaxelMarketMainFeatures from './routes/main_features/component/editPaxelMarketMainFeatures.vue';
import PaxelMarketJoinProcedure from './routes/join_procedure/PaxelMarketJoinProcedure.vue';
import CreatePaxelMarketJoinProcedure from './routes/join_procedure/component/createPaxelMarketJoinProcedure.vue';
import EditPaxelMarketJoinProcedure from './routes/join_procedure/component/editPaxelMarketJoinProcedure.vue';
import CreatePaxelMarketSOP from './routes/sop/component/createPaxelMarketSOP.vue';
import EditPaxelMarketSOP from './routes/sop/component/editPaxelMarketSOP.vue';
import PaxelMarketSOP from './routes/sop/PaxelMarketSOP.vue';
import PaxelMarketPartners from './routes/partners/PaxelMarketPartners.vue';
import CreatePaxelMarketPartners from './routes/partners/component/createPaxelMarketPartners.vue';
import EditPaxelMarketPartners from './routes/partners/component/editPaxelMarketPartners.vue';

const PaxelinMarketRoutes = [
    {
        path: 'message-template',
        name: 'MessageTemplate',
        component: MessageTemplate,
    },
    {
        path: 'message-test',
        name: 'MessageTest',
        component: MessageTest,
    },
    {
        path: 'paxelmarket-main-header',
        name: 'PaxelMarketMainHeader',
        component: PaxelMarketMainHeader,
    },
    {
        path: 'paxelmarket-meta',
        name: 'PaxelMarketMeta',
        component: PaxelMarketMeta,
    },
    {
        path: 'paxelmarket-basic-service',
        name: 'PaxelMarketBasicService',
        component: PaxelMarketBasicService,
    },
    {
        path: 'paxelmarket-basic-service/create',
        name: 'createPaxelMarketBasicService',
        component: CreatePaxelMarketBasicService,
    },
    {
        path: 'paxelmarket-basic-service/:id/edit',
        name: 'editPaxelMarketBasicService',
        component: EditPaxelMarketBasicService,
    },
    {
        path: 'paxelmarket-main-features',
        name: 'PaxelMarketMainFeatures',
        component: PaxelMarketMainFeatures,
    },
    {
        path: 'paxelmarket-main-features/create',
        name: 'createPaxelMarketMainFeatures',
        component: CreatePaxelMarketMainFeatures,
    },
    {
        path: 'paxelmarket-main-features/:id/edit',
        name: 'editPaxelMarketMainFeatures',
        component: EditPaxelMarketMainFeatures,
    },
    {
        path: 'paxelmarket-join-procedure',
        name: 'PaxelMarketJoinProcedure',
        component: PaxelMarketJoinProcedure,
    },
    {
        path: 'paxelmarket-join-procedure/create',
        name: 'createPaxelMarketJoinProcedure',
        component: CreatePaxelMarketJoinProcedure,
    },
    {
        path: 'paxelmarket-join-procedure/:id/edit',
        name: 'editPaxelMarketJoinProcedure',
        component: EditPaxelMarketJoinProcedure,
    },
    {
        path: 'paxelmarket-sop',
        name: 'PaxelMarketSOP',
        component: PaxelMarketSOP,
    },
    {
        path: 'paxelmarket-sop/create',
        name: 'createPaxelMarketSOP',
        component: CreatePaxelMarketSOP,
    },
    {
        path: 'paxelmarket-sop/:id/edit',
        name: 'editPaxelMarketSOP',
        component: EditPaxelMarketSOP,
    },
    {
        path: 'paxelmarket-partners',
        name: 'PaxelMarketPartners',
        component: PaxelMarketPartners,
    },
    {
        path: 'paxelmarket-partners/create',
        name: 'createPaxelMarketPartners',
        component: CreatePaxelMarketPartners,
    },
    {
        path: 'paxelmarket-partners/:id/edit',
        name: 'editPaxelMarketPartners',
        component: EditPaxelMarketPartners,
    },
];

export default PaxelinMarketRoutes;
